import Glide from "@glidejs/glide";

/** @type {Map<Element, import("@glidejs/glide").default>} */
const glideInstances = new Map();

/**
 * Mount a Glide instance on an image gallery carousel.
 *
 * @param {Element} carousel The .glide-cirrus-image-gallery element.
 * @returns {import("@glidejs/glide").default}
 */
function mountGallery(carousel) {
	const glide = new Glide(carousel, {
		type: "slider",
		perView: 2,
		gap: 0,
		bound: true,
		breakpoints: {
			768: {
				perView: 1,
			},
			992: {
				perView: 2,
			},
		},
	});

	glide.mount();
	glideInstances.set(carousel, glide);

	return glide;
}

document.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".glide-cirrus-image-gallery").forEach((carousel) => {
		mountGallery(carousel);
	});
});

document.addEventListener("cfs:modal:opened", (event) => {
	const modal = event.detail && event.detail.modal;
	if (!modal) {
		return;
	}

	modal.querySelectorAll(".glide-cirrus-image-gallery").forEach((carousel) => {
		const existing = glideInstances.get(carousel);
		if (existing) {
			existing.destroy();
			glideInstances.delete(carousel);
		}

		const glide = mountGallery(carousel);
		glide.update();
	});
});
